import React from 'react'

import ReadOnlyApplicationStatus from 'components/ReadOnlyStatusHeader/ReadOnlyApplicationStatus'
import OPEApplicationForm from 'containers/ApplicationSubmissionForms/OPEApplication/OPEApplicationForm'
import PowersportsApplicationForm from 'containers/ApplicationSubmissionForms/PowersportsApplication/PowersportsApplicationForm'
import RVApplicationForm from 'containers/ApplicationSubmissionForms/RVApplication/RVApplicationForm'
import ErrorPage from 'pages/ErrorPage'
import LoadingPage from 'pages/LoadingPage/LoadingPage'
import NotFound from 'pages/NotFound'
import AssetType from 'state/enums/AssetType'

import { useReadOnlyApplication } from '../hooks/useReadOnlyApplication'
import getApplicationData from './getApplicationData'
import { Container, Signature } from './ReadOnlyApplication.styled'

export default function ReadOnlyApplication() {
    const { id, error, loading, appData, appStatus, applicantName } =
        useReadOnlyApplication(getApplicationData)

    if (loading) {
        return <LoadingPage />
    }

    if (error) {
        return (
            <ErrorPage
                title="Failed to load application"
                body={
                    'An error occurred when trying to load the application. ' +
                    'Please try again. If the problem persists, contact us.'
                }
                errorData={{ error, context: { application: { id } } }}
            />
        )
    }

    let FormComponent

    if (appStatus.asset_type === AssetType.RECREATIONAL_VEHICLE) {
        FormComponent = RVApplicationForm
    } else if (appStatus.asset_type === AssetType.POWERSPORTS_VEHICLE) {
        FormComponent = PowersportsApplicationForm
    } else if (appStatus.asset_type === AssetType.OUTDOOR_POWER_EQUIPMENT) {
        FormComponent = OPEApplicationForm
    } else {
        return <NotFound />
    }

    return (
        <Container>
            <ReadOnlyApplicationStatus
                id={appStatus.id}
                applicant={applicantName}
                status={appStatus.status}
                lender={appStatus.lender_name}
                submittedAt={appStatus.submitted_at}
                createdAt={appStatus.created}
                copyingBlocker={appStatus.copying_blocker}
                hasActiveContracts={appStatus.has_active_contracts}
                redecisionBlockers={appStatus.redecision_blockers}
            />
            <FormComponent
                isReadOnly
                isLoading={loading}
                overrideDefaultInitialValues={appData}
            />
            <Signature>Customer signature</Signature>
        </Container>
    )
}
